import React, { useState } from "react";
import PropTypes from "prop-types";
import moment from "moment";
import { AppUtils } from "@src/utils";
import { useAuthContext } from "@src/context";
import AdminHooks from "@src/context/hooks/adminHooks";
import {
  BackButton,
  Button,
  CustomerDropDown,
  DropDown,
  FormInput,
  Loader,
  Modal,
  TabSelector,
  Tag,
} from "@src/components/atoms";
import ErrorPage from "@src/components/layout/ErrorPage";
import { CardContainer } from "@src/components/cards";
import { UsersSection } from "../shared/UsersSection";
import { InAppNotificationViewModal } from "../../../components/cards/operator/InAppNotificationViewModal";
import NotificationDetailModal from "./NotificationDetailModal";

/** Notification table: Single table row */
const NotificationRow = ({ item, onClick }) => {
  const isStruck = !item.sent || item.filtered || item.frequencyLimited;

  return (
    <div
      className={`flex items-center justify-between py-px odd:bg-neutral-100
        ${isStruck ? "line-through text-neutral-500 opacity-75" : ""}
        ${!!onClick ? "cursor-pointer hover:outline active:translate-y-px" : ""}
      `}
      title={JSON.stringify(item, null, 2)}
      onClick={() => onClick(item)}
    >
      {/* Left side */}
      <div className="flex items-center gap-3">
        <div className="flex items-center gap-1">
          <Tag color="primary">
            {{ EMAIL: "📧", INAPP: "🖥" }[item.type] || ""} {item.type}
          </Tag>
          <Tag color="neutral-200" textSize="xs">
            {item.template}
          </Tag>
          {!isStruck && (
            <span className="text-sm truncate">{item.SUBJECT}</span>
          )}
          {item.filtered && <Tag color="yellow">filtered</Tag>}
          {item.frequencyLimited && <Tag color="yellow">frequency limited</Tag>}
        </div>
      </div>

      {/* Right side */}
      <div className="text-sm text-right me-2">
        {!item.sentAt && <>(Not Sent according to Signol records)</>}
        {item.sentAt && (
          <div>
            <span className="text-neutral-400 mx-2">
              {moment(item.sentAt).fromNow()}
            </span>
            {moment.utc(item.sentAt).format("ll HH:mm")}
          </div>
        )}
      </div>
    </div>
  );
};

const NotificationList = ({ operator }) => {
  const auth = useAuthContext();
  const { operatorCode, customerCode } = operator;
  const {
    data: notifications,
    isPending: isPendingNotifications,
    isError: isErrorNotifications,
    //error: errorAll,
  } = AdminHooks.useGetOperatorNotifications(
    auth.activeRole,
    customerCode,
    operatorCode,
  );

  const [selectedNotification, setSelectedNotification] = useState(null);

  return (
    <div>
      {/* NOTIFICATIONS LIST */}
      <CardContainer padding={4}>
        {isPendingNotifications ? (
          <Loader />
        ) : isErrorNotifications ? (
          "🔥 error fetching notifications"
        ) : (
          <div className="max-h-96 overflow-y-auto">
            <h2>{notifications.length} notifications:</h2>
            {notifications.map((n) => (
              <NotificationRow
                key={n._id}
                item={n}
                onClick={(n) => setSelectedNotification(n)}
              />
            ))}
          </div>
        )}
      </CardContainer>

      <NotificationDetailModal
        notificationId={selectedNotification?._id}
        handleClose={() => setSelectedNotification(null)}
      />
    </div>
  );
};
export default NotificationList;
